/* eslint-disable no-underscore-dangle */

/**
 * __PRELOADED_STATE__
 * @namespace
 * @global
 */
if (!window.__PRELOADED_STATE__) {
	window.__PRELOADED_STATE__ = {};
}

const { __PRELOADED_STATE__ = { brand: {}, account: {} } } = window;

delete window.__PRELOADED_STATE__;

const preloadedState = typeof __PRELOADED_STATE__ === 'string' ? JSON.parse(__PRELOADED_STATE__) : __PRELOADED_STATE__;
if (window.__KOMIGEN_TRANSLATIONS__) {
	preloadedState.translations = window.__KOMIGEN_TRANSLATIONS__;
	delete window.__KOMIGEN_TRANSLATIONS__;
}

export default preloadedState;
